/**
 * manifest.js — ELYON-IOT-V2-PR1-1 (Pulse 15)
 *
 * Runtime module manifest consumed by the v2 shell ModuleLoader/AppRouter
 * (ELYON-SHELL-FOUNDATION-1). The shell builds routes from `screens[]` and the
 * module-level sidebar entry from `icon` + `defaultRoute`. This is the canonical
 * wiring for the PR-IOT-1 Tier 1+2 surfaces; the legacy routes.js + sidebar.js
 * are retained for the route-smoke gate and the legacy shell.
 *
 * Enablement prereq: 'iot' in tenantConfig.enabled_modules (demo seed ensures
 * this for elyon-demo; see iotV2Seed.ensureDemoTenantIot).
 */
export default {
  id: 'iot',
  label: 'IoT & Visibility',
  icon: 'Radio',
  path: '/iot',
  defaultRoute: '/iot/command-center',
  screens: [
    // TIER 2 — operator internal (command center is the landing)
    { path: '/iot/command-center',    component: () => import('./screens/IoTCommandCenter.jsx'), label: 'Command Center', icon: 'LayoutDashboard' },
    { path: '/iot/devices',           component: () => import('./screens/DeviceManagement.jsx'), label: 'Devices',        icon: 'Cpu' },
    { path: '/iot/devices/:deviceId',  component: () => import('./screens/DeviceDetail.jsx'),      label: 'Device Detail',  icon: 'Cpu' },
    { path: '/iot/alert-rules',       component: () => import('./screens/AlertRules.jsx'),         label: 'Alert Rules',    icon: 'Bell' },
    { path: '/iot/threshold-config',  component: () => import('./screens/ThresholdConfig.jsx'),    label: 'Thresholds',     icon: 'Sliders' },
    { path: '/iot/ingestion',         component: () => import('./screens/IngestionConfig.jsx'),    label: 'Ingestion',      icon: 'Plug' },
    // IOT-S2b — provisioning wizard + remote config + shipment init
    { path: '/iot/provisioning-wizard', component: () => import('./screens/ProvisioningWizard.jsx'), label: 'Provision Wizard', icon: 'Plug' },
    { path: '/iot/bulk-config',         component: () => import('./screens/BulkConfigPush.jsx'),     label: 'Remote Config',    icon: 'Settings' },
    { path: '/iot/shipment-init',       component: () => import('./screens/ShipmentInit.jsx'),       label: 'Shipment Init',    icon: 'Package' },
    // IOT-S6a — Benchmarking + Lane-Risk Analytics
    { path: '/iot/lane-benchmarking', component: () => import('./screens/IotLaneBenchmarkingScreen.jsx'), label: 'Lane Benchmarking', icon: 'BarChart2' },
    // TIER 1 — customer-facing
    { path: '/iot/shipper-portal',    component: () => import('./screens/ShipperPortal.jsx'),      label: 'Shipper Portal', icon: 'Eye' },
    { path: '/iot/shipment-map',      component: () => import('./screens/ShipmentMapView.jsx'),    label: 'Shipment Map',   icon: 'MapPin' },
  ],
  requiredPermissions: [],
  substrate_consumers: ['DataService', 'AEGIS', 'EventBus', 'MapService'],
};
